<p id="cookie-banner" *ngIf="hasAcceptedCookies === false">
  {{ 'COOKIE_BANNER_MESSAGE' | translate }}
  <a (click)="openTermsOfServiceModal($event)" target="_blank" title="To terms of service">{{
    'TERMS_OF_SERVICE' | translate
  }}</a
  >.
  <span class="label-close" (click)="acceptCookies()"> OK </span>
</p>
